import Botox from "../";

const routes = [
    { name: "Home Botox", path: "/homebotox", component: Botox.HomeBotoxList, meta: { title: "Home Botox" } },
    { name: "Botox Configurazione Diagnosi", path: "/configurazione/botoxdiagnosi", component: Botox.BotoxConfigurazioneDiagnosiListPage, meta: { title: "Configurazione Diagnosi" } },
];

export default routes;
